import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { lookupAffiliateByCode } from "@/lib/affiliate.functions";
import { writeAffiliateCookie } from "@/lib/ecom/affiliate-cookie";
import ShopIndex from "@/routes/shop";

export const Route = createFileRoute("/sale/$id")({
  component: SalePage,
});

function SalePage() {
  const { id } = Route.useParams();
  const lookupFn = useServerFn(lookupAffiliateByCode);
  const [state, setState] = useState<
    | { status: "checking" }
    | { status: "invalid" }
    | { status: "ok"; name: string }
  >({ status: "checking" });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const a = await lookupFn({ data: { code: id } });
        if (cancelled) return;
        if (!a) {
          setState({ status: "invalid" });
          return;
        }
        // Prefer link code (canonical) but fall back to whichever matched.
        writeAffiliateCookie(a.affiliate_link_code || a.discount_code);
        const display =
          a.name?.trim() ||
          [a.first_name, a.last_name].filter(Boolean).join(" ").trim() ||
          "a Banana partner";
        setState({ status: "ok", name: display });
      } catch {
        if (!cancelled) setState({ status: "invalid" });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, lookupFn]);

  if (state.status === "invalid") {
    return <Navigate to="/shop" replace />;
  }

  return (
    <>
      {state.status === "ok" && (
        <div className="bg-foreground py-2.5 text-center text-[12px] font-semibold text-background sm:text-[13px]">
          You're shopping via <span className="font-bold">{state.name}</span> — enter their code at checkout for 10% off.
        </div>
      )}
      <ShopIndex />
    </>
  );
}
